// imports
import React, { useId } from 'react';

// interfaces / types / consts
export interface Props {
  label?: string;
  checked: boolean;
  onChanged: () => void;
}

// exports
export default function Checkbox(props: Props): JSX.Element {
  const { label, checked, onChanged } = props;
  // hooks configuration
  const uniqueId = useId();

  // render
  return (
    <div className="checkbox">
      <label htmlFor={`checkbox-${uniqueId}`}>
        <input
          type="checkbox"
          checked={checked}
          onChange={onChanged}
          id={`checkbox-${uniqueId}`}
        />
        <span className="checkmark" />
        <span className="checkmark-text">{label}</span>
      </label>
    </div>
  );
}

// default props
Checkbox.defaultProps = { label: '' };
